import React, { useState } from "react";
import { MessageCircle, X, Send, Trees } from "lucide-react";

const WhatsAppWidget = () => {
  const PHONE_NUMBER = "+4915735547097";
  const AGENT_NAME = "Palloshi Galabau";
  const WELCOME_MESSAGE = "Hallo! 👋 Planen Sie ein Gartenprojekt oder benötigen Sie Pflege für Ihre Außenanlage? Schreiben Sie uns!";

  const [isOpen, setIsOpen] = useState(false);
  const [userMessage, setUserMessage] = useState("");

  const handleSendMessage = () => {
    if (!userMessage.trim()) return;
    const encodedMessage = encodeURIComponent(userMessage);
    const url = `https://wa.me/${PHONE_NUMBER}?text=${encodedMessage}`;
    window.open(url, );
    setUserMessage(""); 
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendMessage();
  };

  return (
    /* 
       👇 THE FIX:
       1. z-[9999]: Always on top.
       2. pointer-events-none: This wrapper is transparent to clicks.
    */
    <div className="fixed bottom-6 right-6 flex flex-col items-end gap-4 font-sans text-slate-800 z-[9999] pointer-events-none">
      
      {/* WHATSAPP MODAL WINDOW */}
      <div 
        /* 👇 pointer-events-auto: Makes the chat window clickable again */
        className={`
          w-[350px] max-w-[85vw] bg-[#e5ddd5] rounded-2xl shadow-2xl overflow-hidden border border-gray-200 
          transition-all duration-300 origin-bottom-right transform pointer-events-auto
          ${isOpen 
            ? "opacity-100 scale-100 translate-y-0 visible" 
            : "opacity-0 scale-95 translate-y-10 invisible"}
        `}
      >
        {/* HEADER */}
        <div className="p-4 flex justify-between items-center text-white bg-[#075E54]">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center overflow-hidden">
                <Trees className="text-[#075E54]" size={20} />
              </div>
              <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-[#075E54] rounded-full"></div>
            </div>
            <div>
              <h4 className="font-bold text-base leading-tight">{AGENT_NAME}</h4>
              <p className="text-[11px] text-green-100 opacity-90 leading-tight">Online</p>
            </div>
          </div>
          <button 
            onClick={() => setIsOpen(false)} 
            className="hover:bg-white/10 p-2 rounded-full transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* CHAT BODY */}
        <div className="relative h-80 p-4 flex flex-col overflow-y-auto">
          <div 
            className="absolute inset-0 opacity-20 z-0 pointer-events-none"
            style={{ 
              backgroundImage: "url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d936a28b80.png')",
              backgroundSize: "400px" 
            }}
          ></div>

          <div className="bg-white p-3 rounded-lg rounded-tl-none shadow-sm text-[13px] self-start max-w-[85%] mb-2 relative z-10">
            <span className="block text-[11px] font-bold text-[#075E54] mb-1">{AGENT_NAME}</span>
            {WELCOME_MESSAGE}
            <span className="block text-[10px] text-gray-400 text-right mt-1">
              {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
          </div>
        </div>

        {/* FOOTER / INPUT */}
        <div className="p-3 bg-[#f0f2f5] flex items-center gap-2 border-t border-gray-200">
          <input 
            type="text" 
            value={userMessage}
            onChange={(e) => setUserMessage(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Nachricht schreiben..." 
            className="flex-1 bg-white rounded-full px-4 py-2 text-sm outline-none border border-gray-100 focus:ring-1 focus:ring-[#075E54]"
          />
          <button 
            onClick={handleSendMessage}
            className="p-2.5 rounded-full text-white bg-[#075E54] hover:scale-105 transition-transform disabled:opacity-50"
            disabled={!userMessage.trim()}
          >
            <Send size={18} />
          </button>
        </div>
      </div>

      {/* FLOATING TRIGGER BUTTON */}
      <button 
        onClick={() => setIsOpen(!isOpen)}
        /* 👇 pointer-events-auto: Makes the button clickable again */
        className="relative p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center bg-[#25D366] text-white z-50 pointer-events-auto"
        aria-label="Chat on WhatsApp"
      >
        {!isOpen && (
          <span className="absolute top-0 right-0 -mt-1 -mr-1 flex h-5 w-5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-5 w-5 bg-red-500 text-[10px] font-bold items-center justify-center border border-white">1</span>
          </span>
        )}
        
        <div className="relative w-8 h-8 flex items-center justify-center">
          <MessageCircle 
            size={32} 
            className={`absolute transition-all duration-300 ${isOpen ? 'opacity-0 scale-50 rotate-90' : 'opacity-100 scale-100 rotate-0'}`} 
          />
          <X 
            size={32} 
            className={`absolute transition-all duration-300 ${isOpen ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-50 -rotate-90'}`} 
          />
        </div>
      </button>

    </div>
  );
};

export default WhatsAppWidget;